import useMain from 'hooks/useMain';
import _ from 'lodash';
import { BC_TYPE, SETTING_TYPE } from 'pages/module/constant';
import { useEffect, useMemo, useState } from 'react';
import { micService } from 'services/mic';
import {
  rFetchCategories,
  rFetchCompanies,
  rFetchConcretes,
  rFetchFloors,
  rFetchLocations,
  rFetchRegions,
  rFetchSteps,
  setState
} from 'store/reducers/comModule';
import { handleAsyncCall, mapListToOptions, OptionUtils } from 'utils/common';

export const useSetting = () => {
  const { t, useNavigate, useLocation, dispatch, useSelector, project, upperCaseLang } = useMain();
  const location = useLocation();
  const isLoading = useSelector((s) => s.comModule.isLoading);
  const setLoading = (loadingState) => dispatch(setState(['isLoading', loadingState]));
  const currentSettingType = useSelector((state) => state.comModule.settingType);
  const bcTypes = useSelector((state) => state.comModule.bcTypes);
  const categories = useSelector((state) => state.comModule.categories);
  const subCategories = useSelector((state) => state.comModule.subCategories);
  const companies = useSelector((state) => state.comModule.companies);
  const concretes = useSelector((state) => state.comModule.concretes);
  const [rows, setRows] = useState([]);
  const [rifdList, setrifdList] = useState([]);
  const [companyTypeOptions, setCompanyTypeOptions] = useState([]);
  const bcTypeOptions = OptionUtils.localizeBctypeOptions(bcTypes, upperCaseLang);

  useEffect(() => {
    const cst = Object.values(SETTING_TYPE).find((type) => {
      return location.pathname.toLowerCase().match(type.toLowerCase());
    });

    dispatch(setState(['bctype', '']));
    dispatch(setState(['settingType', cst]));
  }, [location.pathname]);
  useEffect(() => {
    if (currentSettingType === SETTING_TYPE.COMPANY) {
      handleAsyncCall({
        service: micService.getCompanyTypes,
        successCb: (r) => {
          const translationKeys = {
            Contractor: 'CONTRACTOR',
            HingeSupplier: 'HINGE_SUPPLIER',
            RSCompany: 'RS_COMPANY',
            SOCAM: 'SOCAM',
            Manufacturer: 'MANUFACTURER',
            Other: 'OTHER'
          };
          const companyTypeOptions = (r?.data || []).map((item) => {
            const key = translationKeys[item.Type];
            return {
              label: key ? t(key) : item.Type,
              value: item.Type
            };
          });
          setCompanyTypeOptions(companyTypeOptions);
        }
      });
    }
  }, [t, currentSettingType]);

  const fetchRows = () => {
    let service = micService.getSettingData;

    if (currentSettingType === SETTING_TYPE.GPSHISTORY) {
      handleAsyncCall({
        service: micService.getRfidListWithFilters,
        params: {
          projid: project.ProjId,
          data: { Bctype: [BC_TYPE.MIC] }
        },
        successCb: (res) => {
          setrifdList(mapListToOptions(res.data, 'RfidtagNo', 'Id'));
        }
        // setDetailBlock: setLoading
      });

      service = micService.getGpsHistory;
    }
    if (currentSettingType === SETTING_TYPE.VEHICLE) {
      service = micService.getVehicles;
    }

    handleAsyncCall({
      service,
      params: {
        projid: project?.ProjId,
        masterType: currentSettingType
      },
      successCb: (res) => {
        let dataWithId = res.data;
        if (!res.data[0]?.Id) {
          dataWithId =
            res?.data.map((d, i) => ({
              Id: `setting-${currentSettingType}-data-${i}`,
              ...d
            })) || [];
        }

        setRows(dataWithId);
      }
    });
  };

  useEffect(() => {
    if (currentSettingType) {
      fetchRows();
      return () => {
        setRows([]);
      };
    }
  }, [currentSettingType]);

  return {
    currentSettingType,
    bcTypeOptions,
    companyTypeOptions,
    isLoading,
    setLoading,
    fetchRows,
    categories,
    rifdList,
    // rows: returnRows(),
    rows,
    rowKey: 'Id'
  };
};
